import React from "react";
import { GOOGLE_CAPTCHA_KEY } from "../constants";
import Modal from "../parts/modal-new";
import submit from "submit-form";
import ReCAPTCHA from "react-google-recaptcha";
import LoginWrapper from "./LoginWrapper";
import OnboardingHeader from "./onboarding/OnboardingHeader";
import OnboardingRadio from "../parts/inputs/onboarding-radio";
import { SignupTextInput } from "../parts/inputs/SignupTextInput";
import SvgIcon from "../parts/SvgIcon";
import Select from "../parts/inputs/select";

const showCoachModal = (email) => {
  return (
    <Modal title="Email address already in use">
      <form
        method="POST"
        action="/signup-coach-existing"
        data-noreset
        className="p-8 pt-6"
      >
        <input type="hidden" name="existing" defaultValue={email} />

        <div className="chip info mb-8">
          <span>Contact us to get free trial access as a coach</span>
        </div>

        <label htmlFor="comment">Message</label>
        <textarea
          className="mb-10"
          required
          name="comment"
          placeholder="Message"
          defaultValue={`Hey! I want access as a coach but my email ${email} is already registered.`}
          rows={4}
        />

        <button data-button-type="primary" type="submit" className="ml-auto">
          Send Message
        </button>
      </form>
    </Modal>
  );
};

const dayOptions = [
  { text: "Sunday", value: 0 },
  { text: "Monday", value: 1 },
  { text: "Tuesday", value: 2 },
  { text: "Wednesday", value: 3 },
  { text: "Thursday", value: 4 },
  { text: "Friday", value: 5 },
  { text: "Saturday", value: 6 },
];

class View extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      step: "profile",
      first_name: "",
      last_name: "",
      email: "",
      businessName: "",
      password: "",
      confirmPassword: "",
      agreeTOS: false,
      avatar: "",
      units: "metric",
      startingCalendarDay: 0,
      intensityMeasure: "rpe",
      round: true,
      hideRepMaximums: false,
      hideE1rm: false,
      hideStrengthMetrics: false,
      errors: {},
      validCaptcha: false,
      referAsClients: false,
      recaptchaTheme: "dark",
    };
    this.selectFile = this.selectFile.bind(this);
    this.handleAvatarChange = this.handleAvatarChange.bind(this);
    this.nextStep = this.nextStep.bind(this);
    this.handleReturnButton = this.handleReturnButton.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleMetricsInput = this.handleMetricsInput.bind(this);
    this.handleintensityMeasureInput =
      this.handleintensityMeasureInput.bind(this);
    this.handleUserReferenceInput = this.handleUserReferenceInput.bind(this);
    this.handleSwitch = this.handleSwitch.bind(this);
    this.handleDaySelect = this.handleDaySelect.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.handleCaptcha = this.handleCaptcha.bind(this);
    this.handleHideRM = this.handleHideRM.bind(this);
    this.handleHideE1rm = this.handleHideE1rm.bind(this);
    this.handleHideStrengthMetrics = this.handleHideStrengthMetrics.bind(this);
    this.handleRound = this.handleRound.bind(this);
  }
  selectFile(e, edit) {
    e.preventDefault();
    e.stopPropagation();
    if (this.state.avatar === "" || edit) {
      document.getElementById("avatar-input").click();
    } else
      this.setState(
        (prevState) => ({ ...prevState, avatar: "" }),
        () => {
          document.getElementById("avatar-input").value = "";
        }
      );
  }
  handleAvatarChange(e) {
    e.persist();
    if (typeof e.target.files[0] === "object") {
      this.setState(
        (prevState) => ({ ...prevState, avatar: e.target.files[0] }),
        () => {
          const reader = new FileReader();
          const img = document.getElementById("avatar");
          reader.onload = (event) => (img.src = event.target.result);
          reader.readAsDataURL(e.target.files[0]);
        }
      );
    }
  }
  handleReturnButton() {
    if (this.state.step === "profile") {
      const url = `/login-new-onboarding/redirect/0`;
      submit(url, {
        method: "GET",
      });
    } else {
      this.setState((prevState) => ({ ...prevState, step: "profile" }));
    }
  }

  nextStep(e) {
    e.preventDefault();
    const validation = this.validateForm("profile");
    if (validation === "success") {
      return this.setState((prevState) => ({
        ...prevState,
        step: "preferences",
        errors: {},
      }));
    } else
      return this.setState((prevState) => ({
        ...prevState,
        errors: validation,
      }));
  }

  validateForm(step) {
    if (step === "profile") {
      if (this.state.first_name.length <= 1)
        return { first_name: "A first name is required." };
      if (this.state.last_name.length <= 1)
        return { last_name: "A last name is required." };
      if (!/.+\@.+\..+/.test(this.state.email))
        return { email: "Please provide a valid email." };
      if (this.state.password.length <= 5)
        return {
          password: "Password length must be at least 6 characters long",
        };
      if (this.state.confirmPassword !== this.state.password)
        return { confirmPassword: "Passwords must match" };
      if (!this.state.agreeTOS)
        return {
          agreeTOS: "You must agree to the Terms and Conditions to continue",
        };
      if (!this.state.validCaptcha) {
        return { recaptcha: "You must confirm that you're not a robot." };
      }
      return "success";
    }
  }

  handleInputChange(e) {
    e.persist();
    this.setState((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  }

  handleMetricsInput(unit) {
    if (unit === this.state.units) return;
    if (unit === "metric") {
      this.setState((prevState) => ({ ...prevState, units: "metric" }));
    } else if (unit === "imperial") {
      this.setState((prevState) => ({ ...prevState, units: "imperial" }));
    }
  }
  handleUserReferenceInput(bool) {
    this.setState((prevSate) => ({ ...prevSate, referAsClients: bool }));
  }
  handleintensityMeasureInput(intensity) {
    if (intensity === this.state.intensityMeasure) return;
    if (intensity === "rpe") {
      this.setState((prevState) => ({ ...prevState, intensityMeasure: "rpe" }));
    } else if (intensity === "rir") {
      this.setState((prevState) => ({ ...prevState, intensityMeasure: "rir" }));
    }
  }

  componentDidMount() {
    const htmlTags = document.getElementsByTagName("html");

    Array.prototype.slice.call(htmlTags).forEach((tag) => {
      if (tag?.attributes?.["data-theme"]?.value === "light") {
        this.setState((prevState) => ({
          ...prevState,
          recaptchaTheme: "light",
        }));
      }
    });

    (function (w) {
      w.fpr =
        w.fpr ||
        function () {
          w.fpr.q = w.fpr.q || [];
          w.fpr.q[arguments[0] == "set" ? "unshift" : "push"](arguments);
        };
    })(window);
    fpr("init", { cid: "9g2bue8j" });
    fpr("click");
    const script = document.createElement("script");
    script.src = "https://cdn.firstpromoter.com/fpr.js";
    script.async = true;
    document.head.appendChild(script);
  }

  handleSwitch(switchOption) {
    if (switchOption === "agreeTOS")
      return this.setState(
        (prevState) => ({ ...prevState, agreeTOS: !prevState.agreeTOS }),
        () =>
          (document.getElementById("agreeTOS-checkbox").checked =
            this.state.agreeTOS)
      );
  }

  handleHideRM(bool) {
    this.setState((prevState) => ({ ...prevState, hideRepMaximums: bool }));
  }

  handleHideE1rm(bool) {
    this.setState((prevState) => ({ ...prevState, hideE1rm: bool }));
  }

  handleHideStrengthMetrics(bool) {
    this.setState((prevState) => ({ ...prevState, hideStrengthMetrics: bool }));
  }

  handleRound(bool) {
    this.setState((prevState) => ({ ...prevState, round: bool }));
  }

  handleDaySelect(value) {
    return this.setState((prevState) => ({
      ...prevState,
      startingCalendarDay: value,
    }));
  }

  handleCaptcha(value) {
    const finalValue = !!value;
    this.setState((prevState) => ({ ...prevState, validCaptcha: finalValue }));
  }

  render() {
    const existingCoach = this.props.flash("existingCoach");

    return (
      <>
        {existingCoach && showCoachModal(this.context.locals.query.email)}
        <LoginWrapper
          mainClass="Onboarding"
          left={
            <>
              <OnboardingHeader
                onBack={this.handleReturnButton}
                active={this.state.step === "profile" ? 1 : 2}
                phrase={
                  this.state.step === "profile" ? "Profile" : "Preferences"
                }
                title={
                  this.state.step === "profile" ? "Sign Up" : "Preferences"
                }
              />
              <form method="POST" data-noreset encType="multipart/form-data">
                {this.context.locals.query.referral && (
                  <input
                    type="hidden"
                    name="referralCode"
                    defaultValue={this.context.locals.query.referral}
                  />
                )}

                <section
                  className={this.state.step === "profile" ? "" : "!hidden"}
                >
                  <div
                    onClick={(e) => this.selectFile(e, true)}
                    className="avatar-wrapper"
                  >
                    <div className="upload-icon-wrapper">
                      <div className="upload-icon"></div>
                    </div>
                    {this.state.avatar !== "" && (
                      <div
                        className="upload-icon-wrapper remove-wrapper"
                        onClick={(e) => this.selectFile(e, false)}
                      >
                        <div className="remove-icon"></div>
                      </div>
                    )}
                    {this.state.avatar === "" ? (
                      <SvgIcon src="/img/new-icons/vuesax-linear-user.svg" />
                    ) : (
                      <img id="avatar" className="avatar" src={""} />
                    )}
                  </div>

                  <input
                    id="avatar-input"
                    className="hidden"
                    type="file"
                    name="avatar"
                    placeholder="Add profile picture"
                    accept="image/*"
                    onChange={(e) => this.handleAvatarChange(e)}
                  />
                </section>

                <section
                  className={this.state.step === "profile" ? "" : "!hidden"}
                >
                  <SignupTextInput
                    label={"First name"}
                    name={"first_name"}
                    required={true}
                    type={"text"}
                    placeholder={"First name"}
                    defaultValue={this.state.first_name}
                    onChange={this.handleInputChange}
                    hasError={!!this.state.errors.first_name}
                    error={this.state.errors.first_name}
                  />
                  <SignupTextInput
                    label={"Last name"}
                    name={"last_name"}
                    required={true}
                    type={"text"}
                    placeholder={"Last name"}
                    defaultValue={this.state.last_name}
                    onChange={this.handleInputChange}
                    hasError={!!this.state.errors.last_name}
                    error={this.state.errors.last_name}
                  />
                  <SignupTextInput
                    label={"Email"}
                    name={"email"}
                    required={true}
                    type={"email"}
                    placeholder={"Email"}
                    defaultValue={this.state.email}
                    onChange={this.handleInputChange}
                    hasError={!!this.state.errors.email}
                    error={this.state.errors.email}
                  />

                  <SignupTextInput
                    label={"Business Name"}
                    name={"businessName"}
                    type={"text"}
                    placeholder={"Business Name"}
                    defaultValue={this.state.businessName}
                    onChange={this.handleInputChange}
                  />

                  <SignupTextInput
                    label={"Password"}
                    name={"password"}
                    required={true}
                    type={"password"}
                    placeholder={"Password"}
                    defaultValue={this.state.password}
                    onChange={this.handleInputChange}
                    hasError={!!this.state.errors.password}
                    error={this.state.errors.password}
                  />

                  <SignupTextInput
                    name={"confirmPassword"}
                    label={"Confirm password"}
                    required={true}
                    type={"password"}
                    placeholder={"Confirm password"}
                    defaultValue={this.state.confirmPassword}
                    onChange={this.handleInputChange}
                    hasError={!!this.state.errors.confirmPassword}
                    error={this.state.errors.confirmPassword}
                  />

                  <div className="relative">
                    <label
                      className="checkbox-input"
                      htmlFor="agreeTOS-checkbox"
                    >
                      <input
                        id="agreeTOS-checkbox"
                        type="checkbox"
                        name="agreeTOS"
                        onChange={() => this.handleSwitch("agreeTOS")}
                        value={this.state.agreeTOS ? "on" : "off"}
                        checked={this.state.agreeTOS}
                        data-has-error={!!this.state.errors.agreeTOS}
                      />
                      I agree to the MyStrengthBook{" "}
                      <a
                        href="https://mystrengthbook.com/terms-of-use/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Terms of Use
                      </a>
                    </label>
                    {this.state.errors.agreeTOS ? (
                      <p className="error">{this.state.errors.agreeTOS}</p>
                    ) : null}
                  </div>
                  <div role="recaptcha-wrapper" className="relative">
                    <ReCAPTCHA
                      sitekey={GOOGLE_CAPTCHA_KEY}
                      onChange={this.handleCaptcha}
                      theme={this.state.recaptchaTheme}
                      size="normal"
                    />

                    {this.state.errors.recaptcha ? (
                      <p className="error">{this.state.errors.recaptcha}</p>
                    ) : null}
                  </div>
                </section>

                <div
                  className={
                    this.state.step === "preferences" ? "mt-16" : "!hidden"
                  }
                >
                  <div className="radio-container">
                    <label htmlFor="startingCalendarDay">
                      First day of the week
                    </label>

                    <div>
                      <Select
                        name="startingCalendarDay"
                        options={dayOptions}
                        value={this.state.startingCalendarDay}
                        onChange={this.handleDaySelect}
                      />
                      <picture className="only-show-mobile">
                        <img src="/img/svg/angle-down.svg" />
                      </picture>
                    </div>
                  </div>

                  <OnboardingRadio
                    label="Preferred measurement system"
                    name="units"
                    onClick={this.handleMetricsInput}
                    options={[
                      {
                        value: "metric",
                        label: "Metric (kg)",
                        defaultChecked: true,
                      },
                      { value: "imperial", label: "Imperial (lbs)" },
                    ]}
                    value={this.state.units}
                  />

                  <OnboardingRadio
                    label="User reference"
                    name="referAsClients"
                    onClick={this.handleUserReferenceInput}
                    options={[
                      {
                        value: false,
                        label: "Athlete",
                        defaultChecked: true,
                      },
                      { value: true, label: "Client" },
                    ]}
                    value={this.state.referAsClients}
                  />

                  <OnboardingRadio
                    label="Intensity rating"
                    name="intensityMeasure"
                    onClick={this.handleintensityMeasureInput}
                    options={[
                      {
                        value: "rpe",
                        label: "RPE",
                        defaultChecked: true,
                      },
                      { value: "rir", label: "RiR" },
                    ]}
                    value={this.state.intensityMeasure}
                    tooltipText="Select the option to prescribe and rate load intensities as either a Rate of Perceived Exertion (RPE) or Reps in Reserve (RiR)."
                  />

                  <OnboardingRadio
                    label="Collect primary lift 1 rep maxes (1RMs) from athletes"
                    name="hideRepMaximums"
                    onClick={this.handleHideRM}
                    options={[
                      {
                        value: false,
                        label: "On",
                        defaultChecked: true,
                      },
                      { value: true, label: "Off" },
                    ]}
                    value={this.state.hideRepMaximums}
                    tooltipText="This setting is for strength coaches who prescribe loads for primary lifts or variations as a % of 1 rep max. The system also uses this for calculating intensities and populating the RPE tables."
                  />

                  <OnboardingRadio
                    label="Estimated 1 rep max on completed sets"
                    name="hideE1rm"
                    onClick={this.handleHideE1rm}
                    options={[
                      {
                        value: false,
                        label: "Show",
                        defaultChecked: true,
                      },
                      { value: true, label: "Hide" },
                    ]}
                    value={this.state.hideE1rm}
                    tooltipText="The system will show an estimated 1 rep max on all completed sets to show real-time strength. Our formula takes into consideration RPE/RiR to be as accurate as possible. If you do not want the users of your app to see this, you can hide it."
                  />

                  <OnboardingRadio
                    label="Strength Training Metric Reports"
                    name="hideStrengthMetrics"
                    onClick={this.handleHideStrengthMetrics}
                    options={[
                      {
                        value: false,
                        label: "Show",
                        defaultChecked: true,
                      },
                      { value: true, label: "Hide" },
                    ]}
                    value={this.state.hideStrengthMetrics}
                    tooltipText="These reports are strictly for advanced powerlifting training. If you are not coaching powerlifting (squat, bench press and deadlift), you can hide them from yourself and your users."
                  />

                  <OnboardingRadio
                    label="Rounding to Gym Increments"
                    name="round"
                    onClick={this.handleRound}
                    options={[
                      {
                        value: true,
                        label: "On",
                        defaultChecked: true,
                      },
                      { value: false, label: "Off" },
                    ]}
                    value={this.state.round}
                    tooltipText="When loads are calculated using a %1RM the loads can be calculated as a value that cannot be loaded on a barbell. When 'on' the calculated loads are rounded to the nearest 2.5."
                  />
                </div>

                <footer>
                  <button
                    data-button-type="primary"
                    onClick={(e) => {
                      if (this.state.step === "profile") this.nextStep(e);
                    }}
                    type={this.state.step === "profile" ? "button" : "submit"}
                    sz="large"
                  >
                    Continue
                  </button>

                  <a href="/login" data-button-type="text-white">
                    Back To Login
                  </a>
                </footer>
              </form>
            </>
          }
        />
      </>
    );
  }
}

const SignupCoach = (app) => {
  app
    .get("/signup-coach", async ({ res, isLoggedIn, flash }) => {
      if (isLoggedIn()) {
        flash("error", "Please log out before trying to sign up");
        return res.redirect("/dashboard");
      }

      return (res.body = <View flash={flash} />);
    })
    .post(
      "/signup-coach-existing",
      async ({ req: { body }, res, api, flash }) => {
        flash("success", "Submission successfully sent");
        const contact = {
          type: `Free Trial Coach - ${body.existing}`,
          message: body.comment,
          email: body.existing,
        };
        await api("contact", { method: "POST", body: contact });
        return res.redirect("/signup-coach");
      }
    )
    .post("/signup-coach", async ({ req, res, api, flash, assert, login }) => {
      const { body, files } = req;
      assert(body.first_name, 400, "A first name is required");
      assert(body.last_name, 400, "A last name is required");
      assert(body.email, 400, "An email address is required");
      assert(body.password, 400, "A password is required");
      assert(body.confirmPassword, 400, "Password confirmation is required");
      assert(
        body.confirmPassword === body.password,
        400,
        "Passwords must match"
      );
      assert(
        body.agreeTOS,
        400,
        "You must agree to the Terms and Conditions to continue"
      );

      body.name = `${body.first_name} ${body.last_name}`;
      delete body.first_name;
      delete body.last_name;
      delete body.agreeTOS;
      // confirm password is only client side, API doesnt expect confirmPassword field
      delete body.confirmPassword;
      //   Just necessary on the frontend side
      delete body.step;
      delete body.errors;
      delete body["g-recaptcha-response"];

      try {
        const resp = await (
          await api("register-coach", {
            method: "POST",
            body,
            files,
          })
        ).json();

        const { token, userId } = await (
          await api("login", {
            method: "POST",
            body,
            files,
          })
        ).json();

        const sessionOptions = { refresh: true, ttl: "1 day" };
        await login({ _id: userId, token }, sessionOptions);
        res.redirect("/onboarding-branding");
      } catch (e) {
        //   handle existing user email error
        if (e.code === 400 && e.message.includes("Email")) {
          flash("existingCoach", true);
        }

        flash("error", e.message);
        res.refreshWith({ email: body.email });
      }
    });
};

export default SignupCoach;
